module.exports = __webpack_public_path__ + "static/slide-4-da380ab20990f745bb01cb2925b302f3.jpg";